<template>
  <div class="main" id="main">
    <div class="matchList">
      <div class="backBox" >
        <div class="orgBox" v-for="(item,index) in showData.value" :key="index">
          <div class="orgName">{{item.org}}</div>
          <div class="orgName">{{item.playerName}}</div>
          <div class="orgName">{{item.count}}</div>
          <div class="orgName">{{item.totalScore}}</div>
        </div>
        <div class="fixed fixedL"
         :class="{
            bronze:
              projectInfo.projectTypeName.indexOf('铜牌')!=-1 &&
              showData.value[0].isWinner == 1,
            gold:
              projectInfo.projectTypeName.indexOf('金牌')!=-1 &&
              showData.value[0].isWinner == 1,
            silver:
              projectInfo.projectTypeName.indexOf('金牌')!=-1 &&
              showData.value[0].isWinner == 0 &&
              showData.value[1].isWinner == 1,
          }"
         ></div>
        <div class="fixed fixedR"
          :class="{
            bronze:
              projectInfo.projectTypeName.indexOf('铜牌')!=-1 &&
              showData.value[1].isWinner == 1,
            gold:
              projectInfo.projectTypeName.indexOf('金牌')!=-1 &&
              showData.value[1].isWinner == 1,
            silver:
              projectInfo.projectTypeName.indexOf('金牌')!=-1 &&
              showData.value[1].isWinner == 0 &&
              showData.value[0].isWinner == 1,
          }"
         ></div>
      </div>
      <div class="svgBox" v-for="(item,index) in showData.value" :key="index">
        <div class="targetContainer">
           <div :class="{ shotType: item.sight == 1 }"></div>
           <div class="playerName"></div>
            <div class="name">{{item.playerName}}</div>
            <div class="playerscore">{{item.totalScore}}</div>
          <component v-if="item.eliminated != 2"
            v-bind:is="svgName"
            :dataitem="item.isSoff ? item.soffPosition : item.position"
            :lastscore="
              lastPosition(item)
            "
            ></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, reactive, toRefs,onMounted } from "vue";
import Paho from "../../common/js/mqtt.js";
import { useRouter } from "vue-router";
import { createState } from "../../store";
import svgm50ar from "../../components/50m/svg50mAR.vue"//步枪
import svgm50ap from "../../components/50m/svg50mAP.vue"
import back from "./back.jpeg"
var opt;
export default {
  components: { svgm50ar, svgm50ap  },
  setup(props,{refs,root}) {
    const showData = props.showData
    const svgName = props.svgName
    return {
      showData,
      svgName,
      projectInfo: reactive(createState).projectInfo,
    };
  },
  props: {  //指定接收的值，必须指定类型
    showData: Object,
    svgName:String
  },
  methods: {
    lastPosition(item) {
      const data = item.isSoff ? item.soffPosition : item.position;
      if (data.length > 0) {
        let position = data[data.length - 1];
        return position.score;
      } else {
        return "";
      }
    },
  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
.backBox{
  width: 100%;
  height: 4rem;
  background-image: url('./back.jpeg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.targetContainer{
  width: 100%;
  height: 5rem;
  transform: scale(var(--transScale));
  margin-top: var(--margin);
  box-sizing: border-box;
  border: 2px solid white;
  background:white;
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  .name{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    width: 70%;
    overflow: hidden;
    height: 1rem;
    line-height: 1rem;
    font-weight: 700;
    font-size: 0.5rem;
    color: #fff;
    text-align: left;
    text-indent: 0.2rem;
  }
  .playerscore{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    font-weight: 700;
    font-size: 0.5rem;
    color: #fff;
    // text-align: right;
    text-indent: 6rem;
    padding-right: 0.3rem;
    box-sizing: border-box;
  }
  .playerName{
    z-index: 2;
    width: 100%;
    height: 1rem;
    background-color:#333399; 
    opacity: 0.7;
    position: absolute;
    top: 0;
    left: 0;
  }
}

.orgName{
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  font-weight: 700;
  font-size: 0.5rem;
  color: #fff;
  
}
.totalScore{
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  font-weight: 700;
  font-size: 0.4rem;
}
.count{
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  font-weight: 700;
  font-size: 0.6rem;
  color: #FF0033;
  background-color:#333399; 
}
.matchList {
  flex: 1;
  height: auto;
  width: 100%;
  background: #fff;
  position: relative;
  .orgBox{
    width: 50%;
    height: auto;
    float: left;
  }
  .svgBox{
    width: 100%;
    height: auto;
    float: left;
  }
}
.main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.headerBox {
  width: 100%;
  height: 1rem;
  position: fixed;
    background: #fff;
    z-index: 2;
    border-bottom: 1px solid #333;
  .title{
    background: #39a9ed;
    height: 1rem;
    width: 100%;
    display: block;
    /deep/.van-ellipsis{
      color: #fff;
      max-width: 80%;
      font-size: 0.4rem;
    }
  }
}

.QF{
  background-color: red;
  color: #fff;
}

</style>